import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import { langPath } from '@/utils/langPath';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface NavItemType {
  label: string;
  path: string;
  icon: string;
}

const NavbarItems = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const listItems: NavItemType[] = [
    {
      label: t('dashboard'),
      path: langPath('/main'),
      icon: Images.NavDashboardIcon,
    },
    {
      label: t('orderList'),
      path: langPath('/order/orderList'),
      icon: Images.NavOrderListIcon,
    },
    {
      label: t('completedOrder'),
      path: langPath('/order/completedOrderList'),
      icon: Images.NavCompletedOrderIcon,
    },
    {
      label: t('myPlayer'),
      path: langPath('/my-player-list'),
      icon: Images.NavMyPlayerIcon,
    },
    {
      label: t('businessProfile'),
      path: langPath('/business-profile'),
      icon: Images.NavBusinessProfileIcon,
    },
    {
      label: t('addProductService'),
      path: langPath('/service-registration'),
      icon: Images.NavServiceAddIcon,
    },
    {
      label: t('customerCenter'),
      path: langPath('/support/customerServiceCenter'),
      icon: Images.NavCustomerCenterIcon,
    },
  ];

  const handleNavigation = (
    e: React.MouseEvent,
    path: string,
    toggle?: () => void
  ) => {
    e.preventDefault();
    if (toggle) toggle();
    if (path) navigate(path);
  };

  const isSelected = (pathname: string, path: string) => {
    return (
      pathname === path || (pathname.startsWith(path + '/') && path !== '/')
    );
  };
  return (
    <NavList>
      {listItems.map((item) => {
        return (
          <NavButton
            key={item.label}
            onClick={(e) => handleNavigation(e, item.path!)}
            data-selected={isSelected(pathname, item.path)}
          >
            <NavImage
              src={item.icon}
              alt={`layout-nav-${item.label}-main-icon`}
            />
            {item.label}
          </NavButton>
        );
      })}
    </NavList>
  );
};

export default NavbarItems;

const NavList = styled.div`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

const NavButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 15px;
  text-decoration: none;
  font-family: ${fonts.family.poppins};
  line-height: 120%;
  font-size: 14px;
  text-align: start;
  color: #6a96f8;
  opacity: 0.5;
  &[data-selected='true'],
  &:hover {
    color: #739af7;
    font-weight: ${fonts.weight.semiBold};
    opacity: 1;
  }
`;

const NavImage = styled.img`
  width: 45px;
  height: 45px;
`;
